import { useQuery, useMutation } from 'react-query'
import axios from '../../utils/axios'
import { API_BASE_URL } from '../../constants'

const fetchUserList = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/person`)

  return data.map(({ user, organisation, ...rest }) => ({
    ...user,
    ...rest,
  }))
}

const fetchOrganisationDetails = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/organisation/details`)
  return data
}

const fetchOrganisationLogs = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/logs/`)
  return data.results || []
}

const fetchLatestLogs = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/logs/latest_logs/`)
  return data
}

const fetchNotifications = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/notifications/unread_logs/`)
  return data
}

const markNotificationsAsRead = async (lastReadLogId) => {
  const { data } = await axios.post(`${API_BASE_URL}/notifications/mark_as_read/`, {
    last_read_log_id: lastReadLogId,
  })
  return data
}

export const useUserList = () => {
  return useQuery(['user-list'], () => fetchUserList())
}

export const useOrganisationDetails = () => {
  return useQuery(['organisation-details'], () => fetchOrganisationDetails())
}

export const useOrganisationLogs = () => {
  return useQuery(['organisation-logs'], () => fetchOrganisationLogs())
}

export const useNotifications = () => {
  const { data: unreadLogs = [] } = useQuery(['unread-notifications'], () => fetchNotifications(), {
    refetchInterval: 15000, // Refetch every 15 seconds
  })

  const { data: latestLogs = [] } = useQuery(['latest-logs'], () => fetchLatestLogs(), {
    refetchInterval: 15000, // Refetch every 15 seconds
  })

  return {
    unreadLogs,
    latestLogs,
    allCount: latestLogs.length,
    unreadCount: unreadLogs.length,
  }
}

export const useMarkNotificationsAsRead = () => {
  return useMutation(markNotificationsAsRead)
}
